const APRROVE_STATUS = {
  APPROVE: 'approved',
  REJECT: 'rejected',
};

export default {
  APRROVE_STATUS,
};
